import React, { useState, useEffect, memo, useCallback } from 'react';
import Stack from '@mui/material/Stack';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import dayjs, { Dayjs } from 'dayjs';

import ActionCalendar from 'src/components/calendar/schedule/ActionCalendar';
import Calendar from 'src/components/task/surgeryCalendar/Calendar';
import WorkSchdule from 'src/components/task/surgeryCalendar/surgerySchedule/SurgerySchedule';
// import { getToken } from 'src/utils/auth';
// import { postAPI } from 'src/utils/api';
import { useStore } from 'src/context/StoreContext';

import { dataExample } from './DataExample';

type ScheduleCustomProps = {
  openFilter: boolean;
};

const currentDate: Dayjs = dayjs();

const urlTab = {
  calendar: '/surgery-calendar',
  schedule: '/surgery-schedule'
};

const dataCalendarDefine = {
  days: [],
  doctors: [],
  times: [],
};

type DataCalendarType = {
  days: any[];
  doctors: any[];
  times: any[];
};

const ScheduleCustom: React.FC<ScheduleCustomProps> = (props) => {
  const storeContext = useStore();
  const setOptionFilter = storeContext.setOptionFilter;
  const dateSelectedStore = storeContext.dateSelected;
  const setIsToday = storeContext.setIsToday;
  const tabCalendar = storeContext.tabCalendar;

  const [calendarData, setCalendarData] =
    useState<DataCalendarType>(dataCalendarDefine);
  const [isLoadingCalendar, setIsLoadingCalendar] = useState<boolean>(false);
  const [yearMonth, setYearMonth] = useState<string>(
    currentDate.format('YYYY-MM')
  );

  // const getCalendarIndex = async (data: any): Promise<string[] | undefined> => {
  //   try {
  //     const token = getToken();

  //     if (!token) {
  //       throw new Error('Failed to get access token');
  //     }

  //     const res = await postAPI(
  //       `/calendar/index?version=v2.0&token=${token}`,
  //       data
  //     );

  //     if (res.code === 200 && res.data) {
  //       return res.data;
  //     } else {
  //       return undefined;
  //     }
  //   } catch (error) {
  //     console.error('Failed to fetch data:', error);
  //     throw error;
  //   }
  // };

  const getOptionFilter = (res: any) => {
    let optionsFilter: any[] = [];
    if (res && res['doctors']) {
      const newOptionFilter = res['doctors'].map((item: any) => ({
        id: item['id'],
        name: item['name'],
        type: 'doctor',
      }));

      optionsFilter = [...newOptionFilter];
    }

    setOptionFilter(optionsFilter);
  };

  // const handleSetCalendarData = (dataRes: any, isTime: boolean = false) => {
  //   if (isTime) {
  //     setCalendarData((prevState) => ({
  //       ...prevState,
  //       times: [...prevState.times, ...dataRes.times],
  //     }));
  //   } else {
  //     setCalendarData({
  //       calendarDays: dataRes['calendar_days'] ? dataRes['calendar_days'] : [],
  //       days: dataRes['days'] ? dataRes['days'] : [],
  //       doctors: dataRes['doctors'] ? dataRes['doctors'] : [],
  //       lastpage: dataRes['lastpage'] ? dataRes['lastpage'] : 0,
  //       machines: dataRes['machines'] ? dataRes['machines'] : [],
  //       nearest: dataRes['nearest'] ? dataRes['nearest'] : 0,
  //       notes: dataRes['notes'] ? dataRes['notes'] : {},
  //       settings: dataRes['settings'] ? dataRes['settings'] : {},
  //       times: dataRes['times'] ? dataRes['times'] : [],
  //     });
  //   }
  // };

  const getAllCalendarIndex = async (month: string, to: string) => {
    setCalendarData(dataExample.data);
    getOptionFilter(dataExample.data);
    setIsLoadingCalendar(false);
  };

  const handleChangeMonth = useCallback(
    async (yearMonth: string) => {
      setYearMonth(yearMonth);
      if (tabCalendar === 'calendar') {
        getAllCalendarIndex(
          dayjs(yearMonth).format('YYYY/MM'),
          dayjs(yearMonth).format('YYYY/MM/DD')
        );
      }
    },
    // eslint-disable-next-line
    [yearMonth, getAllCalendarIndex]
  );

  const handleClickToDay = useCallback(async () => {
    setIsToday(true);
    if (currentDate.format('YYYY-MM') !== yearMonth) {
      setYearMonth(currentDate.format('YYYY-MM'));
    }
    // eslint-disable-next-line
  }, []);

  // const generateRandomString = (length: number): string => {
  //   const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  //   let result = '';
  //   const charactersLength = characters.length;

  //   for (let i = 0; i < length; i++) {
  //     result += characters.charAt(Math.floor(Math.random() * charactersLength));
  //   }

  //   return result;
  // };

  // useEffect(() => {
  //   if (tabCalendar === 'calendar') {
  //     getAllCalendarIndex(
  //       currentDate.format('YYYY/MM'),
  //       currentDate.format('YYYY/MM/DD')
  //     );
  //   }

  //   // eslint-disable-next-line
  // }, []);

  useEffect(() => {
    const dayjsDate = dayjs(dateSelectedStore).format('YYYY-MM');

    if (dateSelectedStore !== '' && dayjsDate !== yearMonth) {
      handleChangeMonth(dayjsDate);
    }
    // eslint-disable-next-line
  }, [dateSelectedStore]);

  const reloadCalendar = useCallback(() => {
    getAllCalendarIndex(
      dayjs(yearMonth).format('YYYY/MM'),
      dayjs(yearMonth).format('YYYY/MM/DD')
    );
    
    // eslint-disable-next-line
  }, [yearMonth]);

  useEffect(() => {
    if (tabCalendar === 'calendar') {
      getOptionFilter(calendarData);

      if (calendarData.days.length === 0) {
        getAllCalendarIndex(
          dayjs(yearMonth).format('YYYY/MM'),
          dayjs(yearMonth).format('YYYY/MM/DD')
        );
      } else {
        const date = calendarData.days[0].day ? calendarData.days[0].day : '';
        if (date !== '' && dayjs(date).format('YYYY-MM') !== yearMonth) {
          getAllCalendarIndex(
            dayjs(yearMonth).format('YYYY/MM'),
            dayjs(yearMonth).format('YYYY/MM/DD')
          );
        }
      }
    }
    // eslint-disable-next-line
  }, [tabCalendar]);

  return (
    <Stack width={'100%'}>
      <ActionCalendar
        onChangeMonth={handleChangeMonth}
        onClickToDay={handleClickToDay}
        yearMonth={yearMonth}
        urls={urlTab}
      />
      {tabCalendar === 'calendar' ? (
        <Calendar
          dataCalendar={calendarData}
          isLoading={isLoadingCalendar}
          dateSelected={dateSelectedStore}
          openFilter={props.openFilter}
          reloadCalendar={reloadCalendar}
        />
      ) : (
        <WorkSchdule
          openFilter={props.openFilter}
          dateSelected={dateSelectedStore}
          yearMonth={yearMonth}
        />
      )}
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoadingCalendar}
      >
        <CircularProgress color='inherit' />
      </Backdrop>
    </Stack>
  );
};

export default memo(ScheduleCustom);
